
import Button from '@/ui-kit/components/button';
import ModalWindow from '@/ui-kit/components/modal/modal-window';
import Typography from '@/ui-kit/components/typography';
import {
  StyleSizeType,
  StyleColorSchemeType,
  StyleFontWeightType,
} from '@/ui-kit/styles/enums';
import { SoldDataEvent } from '@/constants/AnalyticEvents';
import { ButtonProperty, ButtonPropsEventType } from '@/ui-kit/components/button/enums';
import { TypographyType, TypographyProperty } from '@/ui-kit/components/typography/enums';
import { ModalSlotName, ModalViewType } from '@/ui-kit/components/modal/enums';
import ModalCommonProps from '@/ui-kit/components/modal/mixins/ModalCommonProps';
import { track } from '@/utils/analytics';
import SoldDataShareModalForm from './form';
import { soldDataShareFormGroup } from './form/controls';

export default {
  name: 'SoldDataShareModal',
  components: {
    Typography,
    SoldDataShareModalForm,
    ModalWindow,
    Button,
  },
  mixins: [ModalCommonProps],
  data() {
    return {
      TypographyType,
      ModalSlotName,
      ModalViewType,
      StyleSizeType,
      StyleColorSchemeType,
      StyleFontWeightType,
      TypographyProperty,
      ButtonProperty,
      ButtonPropsEventType,
    };
  },
  computed: {
    isFormValid() {
      return soldDataShareFormGroup.isValid;
    },
  },
  methods: {
    validateForm() {
      soldDataShareFormGroup.validate();
    },
    handleSubmit() {
      const formValues = soldDataShareFormGroup.value;

      this.validateForm();
      this.trackShareSearchSendButtonClick();

      if (!this.isFormValid) {
        return;
      }

      this.closeHandler(formValues);
      soldDataShareFormGroup.reset();
    },
    trackShareSearchSendButtonClick() {
      track(SoldDataEvent.ShareSearchSendClick);
    },
  },
};
